<template>
  <div v-if="showEventHelp" class="help-panel">
    <div v-for="def in def.events" :key="def.label" class="definition-object">
      <level-left class="def-header">
        <svgicon v-if="def.icon" class="level-item" :name="def.icon" height="25" width="25">
        </svgicon>
        <h1 class="level-item is-size-6 has-text-weight-semibold">{{ def.label }}</h1>
      </level-left>
      <p><span class="has-text-weight-semibold">Description: </span>{{ def.description }}</p>
    </div>
  </div>
  <div v-else class="help-panel">
    <level-left class="def-header">
      <svgicon v-if="def.icon" class="level-item" :name="def.icon" height="25" width="25"></svgicon>
      <h1 class="level-item is-size-6 has-text-weight-semibold">{{ def.label }}</h1>
    </level-left>
    <p><span class="has-text-weight-semibold">Description: </span>{{ def.description }}</p>
    <field-definition-table :def="def" class="definition-table" ></field-definition-table>
  </div>
</template>

<script>
import _ from 'lodash';
import LevelLeft from '@/components/LevelLeft.vue';
import FieldDefinitionTable from '@/components/analytics/FieldDefinitionTable.vue';

export default {
  name: 'AnalyticHelpPanel',
  components: {
    LevelLeft,
    FieldDefinitionTable,
  },
  props: {
    def: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      expression: '',
    };
  },
  computed: {
    showEventHelp() {
      return _.has(this.def, 'events');
    },
  },
  methods: {
    fields(def) {
      return def.fields.map(field => field.value);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.definition-table {
  border-top: 2px solid #dbdbdb;
}


.definition-object {
  background-color: $form-subitem;
  padding: 10px;
  margin-bottom: 10px;
}

.def-header {
  padding: .5rem $content-padding;
  margin-bottom: .6rem;
  border-bottom: 1px solid $border-color;
  img {
    height: 25px;
    margin-right: 0;
  }
}

p {
  font-size: .9rem;
  margin-bottom: .8rem;
  padding: .5rem $content-padding;
}
</style>
